import 'primeicons/primeicons.css' // Import PrimeIcons CSS globally

import {definePreset} from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import {ToastService} from 'primevue'
import PrimeVue from 'primevue/config'
import type {App} from 'vue'

import setupI18n from './i18n'
import router from './router'
import store from './stores/setup'

export default (app: App) => {
  console.info('Setting up app dependencies...')

  setupI18n(app)
  app.use(store)
  app.use(router)
  app.use(ToastService)

  const customPreset = definePreset(Aura, {
    semantic: {
      primary: {
        50:  '#FFF1EB',
        100: '#FFE0D3',
        200: '#FFC2A8',
        300: '#FFA078',
        400: '#F97C4C',
        500: '#F26022', // base
        600: '#D94F1B',
        700: '#B53E15',
        800: '#8F2F10',
        900: '#6B220B',
        950: '#471606',
      },
    },
  })

  app.use(PrimeVue, {
    theme: {
      preset: customPreset,
      options: {
        prefix: 'p',
        darkModeSelector: 'light',
        cssLayer: false,
      },
    },
  })
}
